/**
 * Asynchronously loads the component for DocumentPage
 */

import * as React from 'react';
import { lazyLoad } from 'utils/loadable';
import { LoadingIndicator } from 'app/components/LoadingIndicator';

export const PersonDocumentsPage = lazyLoad(
  () => import('./PrefillerByLegalProcessAction'),
  module => module.PrefillerByLegalProcessAction,
  {
    fallback: <LoadingIndicator />,
  },
);
